<template>
    <div>
        <div class="Opend">
            <div class="Opend_top">
                <div class="Opend_top_inset">
                    <div v-if="device !== 'mobile'" class="share_box" @click="onMenuItem('Affiliate')">
                        <div>{{ $t("person.InvitationCenter") }}</div>
                        <img src="@/assets/sidebar/invite_free.webp" />
                    </div>
                    <div v-if="device !== 'mobile' && isLogin" class="userMoneyItem" id="userMoneyItem">
                        <div class="userMoneyInfo">
                            <div class="d-flex align-center">
                                <div class="userRefrash" @click="getUserInfo">
                                    <img :class="{'turning':isRefreshingMoney}" src="@/assets/sidebar/icon_refresh.png" />
                                </div>
                                <div @click="getUserInfo">
                                    <div class="d-flex" style="color: rgb(155, 160, 178);">{{ $t("person.Balance") }}</div>
                                    <div class="moneyInfo">{{ CurrencyType }}{{ allBalance }}</div>
                                </div>
                            </div>
                            <div class="userMoneyAdd" @click="onNavTo({ url: '/wallet' })">{{ $t("login.Account") }}</div>
                        </div>
                    </div>
                    <div v-if="device === 'mobile' && isLogin" class="user_info flex">
                        <div class="current-level-wrap flex">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                t="1772705761709" class="icon" viewBox="0 0 1024 1024" version="1.1" p-id="10801"
                                width="200" height="200">
                                <path
                                    d="M237.50144 97.14176c0 0 99.98336-57.56928 134.08256 3.7888 27.25376 18.176 97.69472 396.1344 111.32416 471.10144 13.66016 75.02336 50.01216 102.29248 72.76032 70.46656 22.68672-31.78496 97.67936-106.81856 147.6864-224.95744 50.00704-118.16448-15.89248-133.3248-36.4032-126.49984-20.41344 6.82496-127.22688 9.088-88.59648-36.352 38.64064-45.46048 134.08256-127.27296 159.06304-136.36096 47.71328-31.81056 118.19008-73.48224 177.28-5.2992 36.352 27.264 120.42752 127.27808 38.58432 274.95936-81.78688 147.6864-402.18624 524.89216-402.18624 524.89216s-115.90656 77.27104-163.62496 0c-47.7184-77.21984-202.24-481.71008-206.78656-531.69664-4.54144-50.00192-18.176-63.63136-43.17696-50.00192-25.00096 13.62944-74.98752 88.64256-79.52384 65.8944-4.54656-22.71744-50.00704-49.98144-22.74304-95.42144C62.52032 256.19968 217.0368 113.03424 237.50144 97.14176z"
                                    fill="#8C680C" p-id="10802" />
                            </svg>
                            <p>VIP{{ userInfo && userInfo.levelDetailVo && userInfo.levelDetailVo.memberLevelCode || 0 }}
                            </p>
                        </div>
                        <div class="avatar-wrap">
                            <div class="flex avatar"><img src="@/assets/person/avatar.png" alt="">
                            </div>
                        </div>
                        <div class="user-info">
                            <p class="user-name">Hi, {{ userPhone }}</p>
                            <div class="user-code flex-start" @click="copyText(userInfo.id)">
                                <p>ID: {{ userInfo.id }}</p>
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                    t="1772706119367" class="icon" viewBox="0 0 1024 1024" version="1.1" p-id="13570"
                                    width="200" height="200">
                                    <path
                                        d="M972.7856 256.023999a123.932127 123.932127 0 0 0-36.190869-87.453267L804.214868 36.190869A123.932127 123.932127 0 0 0 716.761601 0v0.479985h-307.1904a153.5952 153.5952 0 0 0-153.5952 153.5952v51.166401H204.8096a153.5952 153.5952 0 0 0-153.5952 153.5952v511.568014a153.5952 153.5952 0 0 0 153.5952 153.5952h409.619199a153.5952 153.5952 0 0 0 153.5952-153.5952v-51.262398H819.1904a153.5952 153.5952 0 0 0 153.5952-153.5952V268.7916v-12.383613zM793.559201 134.3958L838.3898 179.226399h-19.1994A25.727196 25.727196 0 0 1 793.559201 153.5952zM691.226399 870.4048a76.7976 76.7976 0 0 1-76.7976 76.7976H204.8096a76.7976 76.7976 0 0 1-76.7976-76.7976V358.356801a76.7976 76.7976 0 0 1 76.7976-76.7976h51.166401v383.988001a153.5952 153.5952 0 0 0 153.5952 153.5952h281.655198zM895.988 665.547202a76.7976 76.7976 0 0 1-76.7976 76.7976H409.571201a76.7976 76.7976 0 0 1-76.7976-76.7976V153.5952a76.7976 76.7976 0 0 1 76.7976-76.7976H703.994a76.7976 76.7976 0 0 1 12.383613 1.055967V153.5952A102.428799 102.428799 0 0 0 819.1904 256.023999h75.741633A76.7976 76.7976 0 0 1 895.988 268.7916z"
                                        p-id="13571" fill="currentColor" />
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div v-if="device === 'mobile' && !isLogin" class="login-wrap">
                        <div class="sign_up" @click="toLogin(1)">{{ $t("login.SignUp") }}</div>
                        <div class="login_btn" @click="toLogin(2)">{{ $t("login.SignIn") }}</div>
                    </div>
                    <div v-if="device === 'mobile'" class="search_btn" @click.stop="toSearch">
                        <div class="txt"> {{ $t("home.SearchGames") }}</div>
                        <i class="iconfont icon-sousuo"></i>
                    </div>
                   <div class="gameClassify">
                        <div class="item" :class="{'active' : item.id == gameClassifyActId}" v-for="(item, index) in gameClassify" :key="index"
                            @click="gameClassifyItemClick(item, index, $event)">
                            <div class="icon">
                                <img v-if="item.id == gameClassifyActId" :src="item.activationImg">
                                <img v-else :src="item.unActivationImg">
                            </div>
                            <div class="name">{{ item.categoryShowName }}</div>
                        </div>
                    </div>
                    <!-- <div class="event_list">
                        <div class="event_item"
                            :class="[activeList.length >= 4 ? 'W25P' : 'W33P', { act: activeEventId === (item.id || item.eventType || index) }]"
                            v-for="(item, index) in activeList" :key="index" @click="toItem(item)">
                            <img :src="item.homeImgUrl" alt="">
                            <div>{{ item.eventName }}</div>
                        </div>
                    </div> -->
                    <!-- <div class="sidebar_line"></div> -->
                    <div class="menu-group">
                        <div class="menu-item" @click="toCheckIn">
                            <div class="icon">
                                <img src="@/assets/sidebar/nav0.png" alt="">
                            </div>
                            <div>{{ $t("Vip.CheckIn") }}</div>
                        </div>
                        <div class="menu-item" :class="{ 'act': pathAct == 'Event' }" @click="onMenuItem('Event')">
                            <div class="icon">
                                <img src="@/assets/sidebar/nav1.png" alt="">
                            </div>
                            <div>{{ $t("person.Promotion") }}</div>
                            <div class="upto-rate-wrap">
                                <div class="upto-numb">20%</div>
                                <div class="arrow"></div>
                            </div>
                        </div>
                        <div class="menu-item" :class="{ 'act': pathAct == 'vip' }" @click="onMenuItem('vip', true)">
                            <div class="icon">
                                <img src="@/assets/sidebar/nav2.png" alt="">
                            </div>
                            <div>{{ $t("person.VIPClub") }}</div>
                        </div>
                        <div class="menu-item" :class="{ 'act': pathAct == 'Affiliate' }" @click="onMenuItem('Affiliate')">
                            <div class="icon">
                                <img src="@/assets/sidebar/nav4.png" alt="">
                            </div>
                            <div>{{ $t("tabbar.Affiliate") }}</div>
                            <img class="icon_hot" src="@/assets/common/icon_hot.gif" style="">
                        </div>
                        <!-- <div class="menu-item" @click="$refs.RedemptionCodePopup.open()">
                            <div class="icon">
                                <img src="@/assets/common/liwu.png" alt="">
                            </div>
                            <div>{{ $t("RedemptionCode.RedemptionCode") }}</div>
                        </div> -->
                        <div class="menu-item" :class="{ 'act': pathAct == 'JoinChannel' }"
                            @click="onMenuItem('JoinChannel')">
                            <div class="icon">
                               <img src="@/assets/sidebar/nav5.png" alt="">
                            </div>
                            <div>{{ $t("socialMedia.socialMedia") }}</div>
                        </div>
                        <!-- <div class="menu-item" :class="{ 'act': pathAct == 'depositBonus' }"
                            @click="onMenuItem('depositBonus')">
                            <div class="icon">
                                <img class="img" src="@/assets/sidebar/icon_Promotion.png" />
                                <img class="imgAct" src="@/assets/sidebar/icon_PromotionAct.png" />
                            </div>
                            <div>{{ $t("person.Bonus") }}</div>
                        </div> -->
                        <!-- <div class="menu-item" :class="{ 'act': act == 'Bonus' }" @click="onShowDownAppPopup">
                    <div class="icon">
                        <img class="img" src="@/assets/sidebar/icon_Install.png" />
                        <img class="imgAct" src="@/assets/sidebar/icon_InstallAct.png" />
                    </div>
                    <div>{{ $t("person.Install") }}</div>
                </div>
                <div class="menu-item" :class="{ 'act': act == 'Bonus' }"
                    @click="onNavTo({ url: sysConfig.telegram, type: 'href' })">
                    <div class="icon">
                        <i class="iconfont icon-kefuE"></i>
                    </div>
                    <div>{{ $t("person.LiveChat") }}</div>
                </div> -->
                    </div>
                </div>
            </div>
            <div class="Opend_bottom">
                <div class="sidebar_icons_lang">
                    <div class="sidebar_icons">
                        <img v-for="(item, index) in platforms.slice(0, 3)" :key="index" :src="item.icon"
                            @click="onNavTo({ url: item.url, type: 'href' })" />
                    </div>
                    <div class="sidebar_lang">
                        <language :show="true" :showIcon="true">
                            <template #langType>
                                <div class="sidebar_lang_box">
                                    <div class="sidebar_lang_txt">{{ langName }}</div>
                                    <svg v-if="DisabledBelongCountry !== 'disable'" xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 16 16" role="presentation"
                                        class="icon-base_root-F1flk language-picker_arrowIcon-e6Mle" width="16" height="16"
                                        data-icon="arrow-bottom">
                                        <path fill-rule="evenodd"
                                            d="M2.697 5.03a.9.9 0 0 1 1.273 0L8 9.06l4.03-4.03a.9.9 0 1 1 1.273 1.273L8.637 10.97a.9.9 0 0 1-1.273 0L2.697 6.303a.9.9 0 0 1 0-1.273"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </div>
                            </template>
                        </language>
                    </div>
                </div>
                <div class="sidebar_line"></div>
                <div class="sidebar_customerService" @click="onNavTo({ url: sysConfig.telegram, type: 'href' })">
                    <div class="left">
                        <div class="txt">{{ $t("person.LiveChat") }}</div>
                        <div class="btn">24/7<i class="iconfont icon-jiantou1"></i></div>
                    </div>
                    <div class="img_box">
                        <img src="@/assets/sidebar/kefu.png" alt="" >
                    </div>
                </div>
            </div>
        </div>
        <div class="Sidebar-close-icon" @click="handleClickOutside">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" role="presentation"
                class="icon-base_root-F1flk icon-base_m-F1flk" width="24" height="24" data-icon="close">
                <path fill-rule="evenodd"
                    d="M3.364 3.364a.9.9 0 0 1 1.272 0L8 6.727l3.364-3.363a.9.9 0 0 1 1.272 1.272L9.274 8l3.364 3.364a.9.9 0 1 1-1.273 1.272L8 9.274l-3.364 3.364a.9.9 0 1 1-1.272-1.273L6.727 8 3.364 4.636a.9.9 0 0 1 0-1.272"
                    clip-rule="evenodd"></path>
            </svg>
        </div>
        <RedemptionCodePopup ref="RedemptionCodePopup"></RedemptionCodePopup>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { getEventsHomeShow } from '@/api/home'
import { getCustomEventInfo } from '@/api/event'
import { Toast } from 'vant'
import handleCopy from '@/utils/copy.js'
import language from '@/components/language'
import RedemptionCodePopup from '@/components/RedemptionCodePopup'
import { domainKey } from '@/common/http'
import { getUserInfo } from '@/api/user'
import { getGameClassify } from '@/api/game'
import { triggerHome } from '@/store/event'
export default {
    name: 'Sidebar',
    components: { language, RedemptionCodePopup },
    data() {
        return {
            domainKey,
            activeList: [],
            activeEventId: '',
            act: 0,
            hoverAct: 0,
            hoverActTemp: 0,
            isHover: false,
            subAct: 0,
            isShowSub: false,
            PCSubMenus: [],
            pathAct: '',
            platforms: [],
            showPlatformsPopover: false,
            gameClassify: [],
            gameClassifyActId: 'Popular',
            isRefreshingMoney: false
        }
    },
    computed: {
        ...mapState({
            sidebar: state => state.app.sidebar,
            device: state => state.app.device
        }),
        mobile() {
            return this.device === 'mobile'
        },
        isLogin() {
            return !!this.$store.getters.token
        },
        sysConfig() {
            return this.$store.getters.sysConfig
        },
        isCollapse() {
            return !this.sidebar.opened
        },
        userInfo() {
            return this.$store.getters.userInfo
        },
        userPhone() {
            const phone = this.userInfo && this.userInfo.phone
            return phone ? this.maskNumber(phone) : ''
        },
        langName() {
            const type = this.$store.getters.language
            return this.langObj[type].name
        }
    },
    watch: {
        $route: {
            handler: function (to, from) {
                this.act = ''
                this.subAct = ''
                const opt = this.$route?.params
                if (opt && opt.params) {
                    const params = JSON.parse(decodeURIComponent(opt?.params))
                    this.act = params?.code
                    if (params.gameTitleId) this.subAct = params.gameTitleId
                }
                this.pathAct = this.$route.name
            },
            deep: true
        },
        sysConfig: {
            handler: function (newVal, oldVal) {
                if (newVal) {
                    this.GetPlatforms()
                }
            },
            deep: true,
            immediate: true
        }
    },
    created() {
        this.getActiveInfo()
        this.act = ''
        this.subAct = ''
        const opt = this.$route?.params
        if (opt && opt.params) {
            const params = JSON.parse(decodeURIComponent(opt?.params))
            this.act = params?.code
            if (params.gameTitleId) this.subAct = params.gameTitleId
        }
        this.pathAct = this.$route.name
    },
    mounted() {
        this.getGameClassify()
    },
    methods: {
        toCheckIn() {
            this.onNavToByIsLogin({ url: 'SignIn', params: { id: null } })
        },
        gameClassifyItemClick(item, index, event) {
            this.gameClassifyActId = item.id
            item.index = index
            triggerHome(item)
            this.handleClickOutside()
        },
        getGameClassify() {
            getGameClassify().then(res => {
                if (res.code) return
                const D = res.result.filter(x => x.gameTitleIPage && x.gameTitleIPage.records && x.gameTitleIPage.records.length && x.gameCategoryType !== 'None')
                const obj1 = {
                    id: 'Popular',
                    activationImg: require('@/assets/home/icon_hotAct.webp'),
                    unActivationImg: require('@/assets/home/icon_hotAct.webp'),
                    categoryShowName: this.$t('home.Popular'),
                    gameCategoryType: 'Popular',
                    favPageNum: 0,
                    favList: [],
                    RecentList: [],
                    hotPageNum: 1,
                    hotList: []
                }
                D.unshift(obj1)
                this.gameClassify = D
                this.gameClassifyActId = D[0]?.id
            })
        },
        getUserInfo() {
            this.isRefreshingMoney = true
            getUserInfo().finally(() => {
                this.isRefreshingMoney = false
            })
        },
        onMenuItem(act, isLogin) {
            if (this.pathAct === act) {
                Toast(this.$t('lang.CurrentlyPage'))
                return
            }
            this.pathAct = act
            if (isLogin) {
                this.onNavToByIsLogin({ url: act, type: 'post' })
            } else {
                this.onNavTo({ url: act, type: 'post' })
            }
        },
        enterMenuItem(item) {
            if (item !== 'sub') {
                this.PCSubMenus = item
                this.hoverAct = item.id
                this.hoverActTemp = item.id
            } else {
                this.hoverAct = this.hoverActTemp
            }
            if (!this.mobile) this.isHover = true
        },
        leaveMenuItem(item) {
            this.hoverAct = ''
            if (!this.mobile) this.isHover = false
        },
        getActiveInfo() {
            getEventsHomeShow().then((res) => {
                if (!res) return
                if (res.code) return
                const D = res.result
                this.activeList = D.eventManageList
                if (this.activeList.length < 4) {
                    const obj1 = {
                        eventType: 'VIP',
                        homeImgUrl: require('@/assets/vip/vip1.png'),
                        eventName: this.$t('person.VIPClub')
                    }
                    this.activeList.push(obj1)
                }
                if (this.activeList.length < 4) {
                    const obj2 = {
                        eventType: 'customerServiceTelegram',
                        homeImgUrl: require('@/assets/sidebar/icon_telegram.gif'),
                        eventName: this.$t('person.LiveChat')
                    }
                    this.activeList.push(obj2)
                }
                this.$forceUpdate()
                if (D.eventPopupList.length) {
                    D.eventPopupList.forEach(x => {
                        if (x.eventType === 'registerRewards') {
                            this.$store.dispatch('user/setEventRegisterReward', x.eventRewardDescription)
                        }
                    })
                }
            })
        },
        toBonusRainPopup() {
            this.$store.dispatch('user/setIsShowRedPacketPopup', { show: true })
        },
        handleClickOutside() {
            this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
        },
        maskNumber(phoneNumber) {
            const str = phoneNumber.toString()
            if (str.length <= 4) {
                return str
            }
            const firstTwo = str.slice(0, 2)
            const lastTwo = str.slice(-2)
            return `${firstTwo}***${lastTwo}`
        },
        copyText(content) {
            handleCopy(
                {
                    content,
                    success: (msg) => {
                        Toast(msg)
                    },
                    error: (msg) => {
                        Toast(msg)
                    }
                },
                this
            )
        },
        toLogin(type) {
            if (this.isLogin) {
                this.$store.dispatch('user/setIsShowMyProfilePopup', true)
            } else {
                this.$store.dispatch('user/changeLoginType', type)
                this.$store.dispatch('user/setIsShowLoginPopup', true)
            }
        },
        GetPlatforms() {
            this.platforms = []
            const systemConfig = this.sysConfig
            // const facebook = systemConfig.facebook?.trim()
            // if (facebook) {
            //     const platform1 = {
            //         id: 0,
            //         icon: require('@/assets/share/icon_fackbook.png'),
            //         title: 'Facebook',
            //         url: facebook,
            //         linkType: 'href'
            //     }
            //     this.platforms.push(platform1)
            // }
            // const telegram = systemConfig.telegram?.trim()
            // if (telegram) {
            //     const platform2 = {
            //         id: 1,
            //         icon: require('@/assets/share/icon_telegram.png'),
            //         title: 'Telegram',
            //         url: telegram,
            //         linkType: 'href'
            //     }
            //     this.platforms.push(platform2)
            // }
            const telegramGroup = systemConfig.telegramGroup?.trim()
            if (telegramGroup) {
                const platform8 = {
                    id: 1,
                    icon: require('@/assets/share/icon_telegram.png'),
                    title: 'Telegram',
                    url: telegramGroup,
                    linkType: 'href'
                }
                this.platforms.push(platform8)
            }
            const instagram = systemConfig.instagram?.trim()
            if (instagram) {
                const platform3 = {
                    id: 2,
                    icon: require('@/assets/share/icon_ins.png'),
                    title: 'Instagram',
                    url: instagram,
                    linkType: 'href'
                }
                this.platforms.push(platform3)
            }
            // const youTube = systemConfig.youTube?.trim()
            // if (youTube) {
            //     const platform4 = {
            //         id: 3,
            //         icon: require('@/assets/share/icon_youtube.png'),
            //         title: 'Youtube',
            //         url: youTube,
            //         linkType: 'href'
            //     }
            //     this.platforms.push(platform4)
            // }
            const whatsapp = systemConfig.whatsapp?.trim()
            if (whatsapp) {
                const platform5 = {
                    id: 4,
                    icon: require('@/assets/share/icon_whatsapp.png'),
                    title: 'Whatsapp',
                    url: whatsapp,
                    linkType: 'href'
                }
                this.platforms.push(platform5)
            }
            // const twitter = systemConfig.twitter?.trim()
            // if (twitter) {
            //     const platform6 = {
            //         id: 5,
            //         icon: require('@/assets/share/icon_x.png'),
            //         title: 'X',
            //         url: twitter,
            //         linkType: 'href'
            //     }
            //     this.platforms.push(platform6)
            // }
            // const tiktok = systemConfig.tiktok?.trim()
            // if (tiktok) {
            //     const platform7 = {
            //         id: 6,
            //         icon: require('@/assets/share/icon_tiktok.png'),
            //         title: 'TikTok',
            //         url: tiktok,
            //         linkType: 'href'
            //     }
            //     this.platforms.push(platform7)
            // }
        },
        toSearch() {
            this.$store.dispatch('user/setIsShowSearchPopup', true)
        },
        toItem(item) {
            this.activeEventId = item.id || item.eventType
            // console.log(item)
            if (item.eventType === 'reliefMoney') {
                // this.$store.dispatch('user/setIsShowLossSupportPopup', { id: item.id, show: true })
                this.onNavTo({ url: 'WeeklyRescue', params: { id: item.id } })
            }
            if (item.eventType === 'signIn') {
                this.$store.dispatch('user/setIsShowCheckInPopup', { id: item.id, show: true })
                // this.onNavTo({ url: 'SignIn', type: 'post' })
            }
            if (item.eventType === 'vipSignIn') {
                this.onNavToByIsLogin({ url: 'SignIn', params: { id: item.id } })
            }
            if (item.eventType === 'luckyWheel') {
                const params = { id: item.id }
                this.onNavTo({ url: 'Turntable', params })
            }
            if (item.eventType === 'custom') {
                getCustomEventInfo({ id: item.id }).then((res) => {
                    if (res.code) return
                    const D = res.result
                    if (D.displayMode === 'BuiltInPage') {
                        const obj = { id: D.id, eventName: D.eventName, createTime: D.createTime, eventContent: D.eventContent }
                        const params = encodeURIComponent(JSON.stringify(obj))
                        const timestamp = new Date().getTime()
                        this.onNavTo({ url: 'PromotionCustom', type: 'post', params: { timestamp, params } })
                    }
                    if (D.displayMode === 'JumpOutside') {
                        console.log(D.appSkipMode)
                        if (D.appSkipMode === 'newWindowOpen') {
                            const url = D.appHref
                            const type = 'href'
                            this.onNavTo({ url, type })
                        }
                        if (D.appSkipMode === 'nowPageOpen') {
                            // const encodedUrl = encodeURIComponent(D.appHref)
                            // const finalUrl = '/pages/webview/deposit_wv?url=' + encodedUrl
                            // this.onNavTo(finalUrl)
                        }
                        if (D.appSkipMode === 'builtInPageOpen') {
                            const url = D.appHref
                            this.onNavToByIsLogin({ url })
                        }
                    }
                })
            }
            if (item.eventType === 'redPacket') {
                this.$store.dispatch('user/setIsShowRedPacketPopup', { id: item.id, show: true })
            }
            if (item.eventType === 'extend') {
                this.onNavToByIsLogin({}).then(() => {
                    this.$store.dispatch('user/setIsShowTreasureChestPopup', { id: item.id, show: true })
                })
            }
            if (item.eventType === 'gameBetting') {
                this.$store.dispatch('user/setIsShowRebatePopup', { id: item.id, show: true })
            }
            if (item.eventType === 'rechargeRewards') {
                this.onNavTo({ url: '/Affiliate' })
            }
            if (item.eventType === 'gameBettingRewards') {
                this.onNavTo({ url: '/Affiliate' })
            }
            if (item.eventType === 'pinduoduo') {
                this.onNavToByIsLogin({ url: 'Pinduoduo', params: { id: item.id } })
            }
            if (item.eventType === 'rankingList') {
                this.$store.dispatch('user/setIsShowWinRankListPopup', { id: item.id, show: true })
            }
            if (item.eventType === 'registerRewards') {
                const obj = { type: item.eventType }
                const params = encodeURIComponent(JSON.stringify(obj))
                const timestamp = new Date().getTime()
                this.onNavTo({ url: 'PromotionCustom', type: 'post', params: { timestamp, params } })
            }
            if (item.eventType === 'customerServiceTelegram') {
                this.onNavTo({ url: this.sysConfig.telegram, type: 'href' })
            }
            if (item.eventType === 'customerPending') {
                this.$store.dispatch('user/setIsShowPendingPopup', true)
            }
            if (item.eventType === 'totalRecharge') {
                this.$store.dispatch('user/setIsShowDepositTotalPopup', { id: item.id, show: true })
            }
            if (item.eventType === 'rechargeGift') {
                this.$store.dispatch('user/setIsShowDepositRepeatPopup', { id: item.id, show: true })
            }
            if (item.eventType === 'usdtRechargeGift') {
                this.$store.dispatch('user/setIsShowDepositRepeatUsdtPopup', { id: item.id, show: true })
            }
            if (item.eventType === 'VIP') {
                this.onNavToByIsLogin({ url: 'vip' })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/common/styles/viriables.scss';

.Sidebar-close-icon {
    position: absolute;
    background: rgba(255, 255, 255, .3);
    width: .68rem;
    height: .68rem;
    top: .38rem;
    right: -.88rem;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    font-size: .34rem;
    display: none;
    cursor: pointer;

    svg {
        fill: #fff;
    }
}

.Opend {
    display: block;
    height: 100%;
    box-sizing: border-box;
    // padding: 18px 10px;
    // padding-top: 10px;
    padding-right: 0;
    overflow: auto;
    width: 5rem;
    background: linear-gradient(180deg, #4a1d05 0%, #281105 52%, #120b06 100%);
    // box-shadow: 8px 0 8px #00000040;
    // transition-duration: 0.3s;
    position: relative;
    z-index: 2;
    scrollbar-width: none;
    display: flex;
    flex-direction: column;

    &::-webkit-scrollbar {
        display: none;
        /* 对于 Chrome, Safari 和 Opera 隐藏滚动条 */
    }
}

.Opend:after {
    content: "";
    width: 1px;
    height: 100%;
    position: absolute;
    top: 0px;
    right: 0px;
    background: linear-gradient(0deg, rgba(255, 138, 0, .52), rgba(255, 138, 0, 0));
}

.Opend_top {
    flex: 1;
    width: 100%;
    position: relative;

    .Opend_top_inset {

        .gameClassify {
            width: 100%;
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(1rem, 1fr));
            margin-bottom: 0.2rem;
            gap: 0.05rem;
            align-items: center;
            justify-content: space-between;
            .item {
                cursor: default;
                border-radius: 0.14rem;
                padding: 0.1rem 0.1rem 0.12rem;
                font-size: 0.24rem;
                color: #b9a89c;
                .icon {
                    width: 0.5rem;
                    height: 0.5rem;
                    margin: 0px;
                    display: inline-block;
                    > img {
                        width: auto;
                        height: 100%;
                        filter: grayscale(100%);
                    }
                }
                .name {
                    text-transform: capitalize;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                }
            }
            .active {
                background: linear-gradient(90deg, #4a240d, #21150d);
                color: rgb(255, 255, 255);
                .icon {
                    > img {
                        width: auto;
                        height: 100%;
                        filter: none;
                    }
                }
            }
        }

        &::-webkit-scrollbar {
            display: none;
            /* 对于 Chrome, Safari 和 Opera 隐藏滚动条 */
        }

        .flex {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        .flex-start {
            display: flex;
            align-items: center;
            justify-content: flex-start;
        }

        .user_info {
            width: 100%;
            height: 1.8rem;
            margin: 0rem auto .3rem;
            justify-content: center;
            border-radius: .3rem;
            padding: .2rem .15rem;
            position: relative;
            overflow: visible;

            .current-level-wrap {
                position: absolute;
                left: .32rem;
                bottom: .1rem;
                z-index: 10;
                padding: .025rem .12rem;
                border-radius: 0.1rem;
                    background: linear-gradient(90deg, #ffad42, #ff7300);
                border-width: 1px;
                border-style: solid;
                    border-color: #ffad42;
                border-image: none;
                color: #eef8ff !important;
                fill: #eef8ff !important;

                svg {
                    width: .25rem;
                    height: .25rem;
                    margin-right: .05rem;
                    fill: currentColor;
                    color: #eef8ff !important;
                    fill: #eef8ff !important;
                }

                p {
                    font-size: .22rem;
                    line-height: .22rem;
                    font-style: italic;
                    font-weight: 700;
                    text-shadow: 0 1px 1px rgba(0, 0, 0, .3);
                    margin: 0;
                    color: #eef8ff !important;
                }
            }

            .user-info {
                flex: 0 1 100%;
                text-align: left;
                margin-left: .25rem;

                .user-name {
                    font-size: .3rem;
                    font-weight: 500;
                    padding-right: .15rem;
                    margin-right: .15rem;
                    margin-bottom: .1rem;
                    color: #eef8ff !important;
                }

                .user-code {
                    p {
                        color: #eef8ff !important;
                        opacity: .8;
                        font-weight: 500;
                        margin: 0;
                    }

                    svg {
                        width: .3rem;
                        height: .3rem;
                        margin-left: .1rem;
                        fill: currentColor;
                        color: #eef8ff !important;
                    }
                }
            }

            .avatar-wrap {
                display: flex;
                justify-content: center;
                align-items: center;
                position: relative;

                .avatar {
                    width: 1.4rem;
                    height: 1.4rem;
                    border: .04rem solid rgba(255, 255, 255, .3);
                    border-radius: 100px;
                    overflow: hidden;

                    img {
                        width: 100%;
                        height: 100%;
                        pointer-events: none;
                        vertical-align: bottom;
                    }
                }
            }
        }

        .login-wrap {
            width: 100%;
            position: relative;
            display: flex;
            justify-content: space-between;
            margin: .3rem auto .4rem;

            &>div {
                width: 2rem;
                flex: 0 1 49%;
                height: .8rem;
                border-radius: .16rem;
                padding: 0 .1rem;
                font-size: .28rem;
                display: flex;
                align-items: center;
                justify-content: center;

                &.sign_up {
                    background: linear-gradient(145deg, #ff8a00 0%, #e65100 100%);
                    border-color: #06070A;
                    margin-right: .15rem;
                }

                &.login_btn {
                    background: none;
                    border: 1px solid #555;
                    color: #fff;
                }
            }
        }
    }
}

.Opend_bottom {
    // width: 100%;
    position: relative;
    // background: #151618;
    // border: 1px solid #1d1f23;
    border-radius: 18px;
    margin-top: .1rem;
    padding: .05rem;

    &>.sidebar_line {
        width: 100%;
        height: 0px;
        border-top: 1px dashed rgba(255, 255, 255, .16);
        transform: scaleY(.5);
        margin: 19px auto;
    }

    .sidebar_icons_lang {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .sidebar_icons {
            display: flex;
            align-items: center;

            &>img {
                cursor: pointer;
                width: 40px;
                height: 40px;
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 20px;
                color: #fff;
                cursor: pointer;
                font-size: 16px;
                margin-right: 6px;
            }

            .sidebar_icons_more {
                width: .6rem;
                height: .6rem;
                    background: #2b1e15;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: .2rem;
                cursor: pointer;

                svg {
                    fill: #b9a89c;
                }
            }
        }
    }

    .sidebar_customerService {
        display: flex;
        align-items: center;
        width: 100%;
        margin: .3rem auto .2rem;
        border-radius: .2rem;
        padding: .2rem 1rem .2rem .2rem;
        position: relative;
        align-items: center;
        background: none;
        border: 1px solid #4a2d18;
        cursor: default;

        .left {
            .txt {
                font-weight: 500;
                font-size: .3rem;
                line-height: 1.5;
            }
            .btn {
                width: 1.4rem;
                max-height: .46rem;
                margin-top: .1rem;
                justify-content: center;
                font-size: .26rem;
                border-radius: 100px;
                font-weight: 700;
                background: linear-gradient(145deg, #ff8a00 0%, #e65100 100%);;
                color: #06070A;
                overflow: hidden;
            }
        }

        .img_box {
            position: absolute;
            right: 0;
            bottom: 0;
            overflow-x: hidden;
            width: 3.5rem;
            height: auto;
            border-radius: .2rem;
            > img {
                width: 4.7rem;
                height: auto;
                margin-right: 0rem;
            }
        }
    }

    .sidebar_lang {
        display: flex;
        align-items: center;
        background: #18110c;
        border: 1px solid #4a2d18;
        height: .8rem;
        padding: .2rem;
        border-radius: 7px;
        cursor: pointer;

        .sidebar_lang_box {
            display: flex;
            align-items: center;
            justify-content: center;

            .sidebar_lang_txt {
                margin-left: .08rem;
                color: #fff;
                font-weight: bold;
                font-size: .2rem;
            }

            svg {
                fill: #fff;
                font-weight: bold;
            }
        }
    }
}

.share_box {
    height: 72px;
    margin: 20px 11px 15px;
    padding: 16px 10px;
    background:
        radial-gradient(circle at 10% 0, rgba(255, 173, 66, .38) 0, rgba(255, 173, 66, 0) 38%),
        radial-gradient(circle at 82% 0, rgba(255, 115, 0, .28) 0, rgba(255, 115, 0, 0) 36%),
        linear-gradient(90deg, rgba(112, 47, 8, .92) 0%, rgba(77, 31, 6, .94) 48%, rgba(32, 19, 12, .98) 100%);
    border: 1px solid rgba(255, 138, 0, .48);
    box-shadow: inset 0 1px 0 rgba(255, 220, 185, .16), 0 .1rem .22rem rgba(32, 12, 2, .3);
    border-radius: 12px;
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
    cursor: pointer;
    line-height: normal;
    position: relative;

    &>div {
        width: 2.5rem;
        display: block;
        margin-left: 10px;
        position: relative;
        z-index: 1;
        text-align: left;
        color: #fff4eb;
        text-shadow: 0 .02rem .06rem rgba(32, 12, 2, .34);
    }

    &>img {
        position: absolute;
        bottom: -18px;
        right: -3px;
        width: 124px;
        height: 124px;
    }
}

.userMoneyItem {
    position: relative;
    margin: 12px 11px;
    padding: 12px 10px;
    margin-bottom: 16px;
    background: $bg-box-color;
    border: 1px solid $border-color;
    border-radius: 12px;
    font-weight: bold;

    .userMoneyInfo {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: rgba(255, 220, 190, .82);

        .align-center {
            align-items: center !important;
        }

        .d-flex {
            display: flex !important;
        }

        .userMoneyAdd {
            width: 95px;
            height: 40px;
            background:
                linear-gradient(180deg, rgba(255, 246, 235, .26) 0%, rgba(255, 246, 235, .06) 22%, rgba(255, 246, 235, 0) 23%),
                linear-gradient(90deg, #ffad42 0%, #ff8a00 48%, #e65100 100%);
            border: 1px solid rgba(255, 173, 66, .58);
            box-shadow: inset 0 1px 0 rgba(255, 246, 235, .24), 0 0 .18rem rgba(255, 115, 0, .2);
            border-radius: 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            font-size: 14px;
            font-weight: 600;
            margin-left: 10px;
            text-transform: capitalize;
            color: #fff;
        }

        .userRefrash {
            width: 30px;
            height: 30px;
            cursor: pointer;
            margin-right: 10px;
            background:
                linear-gradient(180deg, rgba(255, 230, 204, .12) 0%, rgba(255, 230, 204, 0) .12rem),
                linear-gradient(180deg, rgba(75, 38, 15, .96) 0%, rgba(32, 20, 13, .99) 100%);
            border: 1px solid rgba(255, 138, 0, .34);
            box-shadow: inset 0 1px 0 rgba(255, 230, 204, .12);
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 8px;

            img {
                width: 18px;
                height: 18px;

                &.turning {
                    animation: rotateAni 0.2s linear infinite;
                }

                @keyframes rotateAni {
                    0% {
                        transform: rotate(0deg);
                    }

                    100% {
                        transform: rotate(-360deg);
                    }
                }
            }
        }

        .moneyInfo {
            flex: 1;
            font-size: 16px;
            color: #fff4eb;
        }
    }
}

.search_btn {
    width: 100%;
    border: 1px solid #6d4426;
    margin-bottom: .25rem;
    padding: .15rem .3rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    box-shadow: rgba(0, 0, 0, 0.2) 0px -1px 10px inset;
    border-radius: 0.14rem;
    background: rgba(0, 0, 0, 0.1);
    border: 1px solid #4a2d18;

    .txt {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: .26rem;
        color: #b9a89c;
    }

    .iconfont {
        color: #b9a89c;
        font-weight: bold;
    }
}

.event_list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
    // gap: .16rem;
    margin-bottom: 4px;
    padding: 0 12px;

    .event_item {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        background: rgba(103, 47, 14, .42);
        border: 1px solid rgba(255, 138, 0, .3);
        box-shadow: inset 0 1px 6px rgba(255, 115, 0, .32);
        border-radius: .15rem;
        cursor: pointer;
        height: 1.18rem;
        border-radius: .2rem;
        flex: 1 1 calc(25% - .08rem);
        min-width: 0;
        padding: .13rem .05rem .08rem;
        justify-content: flex-start;
        position: relative;
        overflow: hidden;

        &.W33P {
            width: calc(33.333333% - .18rem);
        }

        &.W25P {
            width: calc(25% - .07rem);
        }

        &>img {
            height: 45px;
            width: 45px;
            vertical-align: middle;
            margin-top: -8px;
        }

        &>div {
            color: #fff;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            width: 100%;
            padding: 0 .08rem;
            font-size: 12px;
        }

        &:hover {
            background: linear-gradient(90deg, rgba(255, 173, 66, .98) 0%, rgba(255, 138, 0, .96) 48%, rgba(230, 81, 0, .94) 100%) !important;
        }

        &.act {
            background: linear-gradient(90deg, rgba(255, 173, 66, .98) 0%, rgba(255, 138, 0, .96) 48%, rgba(230, 81, 0, .94) 100%) !important;
        }
    }
}

.sidebar_line {
    height: .01rem;
    margin: 0 auto;
    background: rgba(240, 242, 245, .1);
    margin-right: .19rem;
}

.menu-group {
    background-color: transparent !important;
    padding: 12px 12px !important;
}

.menu-item {
    width: 100%;
    display: flex;
    align-items: center;
    font-size: .28rem;
    font-weight: 500;
    position: relative;
    cursor: pointer;
    margin-bottom: .15rem;
    height: .75rem;
    padding: 0 .2rem;
    border-radius: .14rem;
    position: relative;
    background: linear-gradient(90deg, #3b210f, #18110c);

    .icon_hot {
        object-fit: contain;
        width: 22px;
        height: 22px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 14px;
        vertical-align: middle;
    }

    .upto-rate-wrap {
        position: absolute;
        top: -7px;
        right: -10px;
        // border-radius: 4px;
        color: #fff;
        animation: uptoAni 1s infinite ease-in-out;
        background: url(@/assets/sidebar/hot1-Byk-tGIM.png) no-repeat center / 100%;
        width: 66px;
        height: 19px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    @keyframes uptoAni {
        0% {
            transform: scale(1)
        }

        50% {
            transform: scale(1.04, 1.1)
        }

        to {
            transform: scale(1)
        }
    }

    .icon {
        padding-right: .1rem;
        > img {
            width: .42rem;
        }
    }

    &.act,
    &:hover {
        color: #fff4eb;
        box-shadow:
            inset 0 1px 0 rgba(255, 244, 235, .2),
            0 0 .2rem rgba(255, 115, 0, .24),
            0 .05rem .12rem rgba(32, 12, 2, .18);
    }
}

.menu-group .menu-item:nth-of-type(1) {
    background: linear-gradient(90deg, #3b210f, #18110c);
}
.menu-group .menu-item:nth-of-type(2) {
    background: linear-gradient(90deg, #432511, #18110c);
}
.menu-group .menu-item:nth-of-type(3) {
    background: linear-gradient(90deg, #4b2911, #18110c);
}
.menu-group .menu-item:nth-of-type(4) {
    background: linear-gradient(90deg, #3b210f, #18110c);
}
.menu-group .menu-item:nth-of-type(5) {
    background: linear-gradient(90deg, #40200e, #18110c);
}
.menu-group .menu-item:nth-of-type(6) {
    background: linear-gradient(90deg, #35200f, #18110c);
}

.Sidebar-close-icon {
    background: linear-gradient(180deg, rgba(255, 190, 102, .92), rgba(255, 115, 0, .94));

    svg {
        fill: #2b1305;
    }
}

.login-wrap>div.login_btn {
    border: 1px solid rgba(255, 138, 0, .42);
    color: #fff0dd;
    background: linear-gradient(180deg, rgba(91, 39, 8, .94) 0%, rgba(38, 20, 11, .98) 100%);
}

.event_list {
    padding: 0 .12rem;
    gap: .1rem;
    margin-bottom: .16rem;
}

</style>
